import React from 'react';
import baseStyles from "./styles.module.css.js";
import useStyleOverride from "../../../hooks/useStyleOverride.js";
export var PopoverContent = _ref => {
  var {
    result
  } = _ref;
  var styles = useStyleOverride('GoogleMaps/Popover/PopoverContent', baseStyles);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.PopoverContent
  }, "lat: ", result.lat, " ", /*#__PURE__*/React.createElement("br", null), "lng: ", result.lng);
};
export default PopoverContent;
//# sourceMappingURL=index.js.map